var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Company Events"}},[_c('DateRange',{model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}}),_c('b-card-body',[_c('CompanyEventTable',{attrs:{"range":_vm.range}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }